var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#twitter_svg__a)",
    fillRule: "evenodd",
    d: "M17.818 6.989c-.354-.508-1.297-1.222-2.827-.914-.891.179-1.425.62-1.764 1.202-.36.62-.535 1.463-.535 2.444a1 1 0 0 1-1 1c-2.367 0-4.618-.703-6.513-2.604a10.5 10.5 0 0 0-.168 2.34c.052 1.086.312 2.175.927 3.108.604.917 1.6 1.757 3.263 2.285a1 1 0 0 1 .41 1.655 8.5 8.5 0 0 1-1.796 1.405c1.06.11 2.082.118 3.03.032 1.92-.174 3.449-.723 4.405-1.5 2.013-1.632 3.09-4.066 2.89-8.144-.033-.67.613-1.393.925-1.942-.47.088-.943.072-1.248-.367M4.593 4.984a1 1 0 0 1 .942.429C7.01 7.572 8.783 8.47 10.749 8.674c.097-.841.324-1.672.75-2.404.626-1.074 1.644-1.864 3.099-2.156 2.009-.404 3.539.324 4.427 1.215l1.792-.335a1 1 0 0 1 1.052 1.478L20.15 9.494c.157 4.361-1.055 7.405-3.64 9.502-1.37 1.112-3.332 1.743-5.485 1.938-2.17.196-4.622-.041-7.06-.753a1 1 0 0 1 .006-1.922c1.226-.349 2.16-.65 3.003-1.177-1.198-.636-2.081-1.468-2.706-2.416-.869-1.318-1.191-2.788-1.255-4.113S3.14 8 3.343 7.115c.114-.505.248-1.011.433-1.495a1 1 0 0 1 .818-.636",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "twitter_svg__a",
    x1: 20.315,
    x2: -16.485,
    y1: 4.469,
    y2: 20.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgTwitter;